import React from "react";

// Abstraction for lazy imports
export const lazyLoad = (path) => React.lazy(() => import(`../Layouts/${path}`));

// Helper for generating menu icons
export const createIcon = (name) => ({
  active: `/menuicon/${name}_active.png`,
  inactive: `/menuicon/${name}_inactive.png`,
});